import React from "react";
import styled from "styled-components";

// components
import CoreTNPLogo from "core/SiteHeader/components/TNPLogo";

// data
import { TNP_LOGO_WIDTH } from "core/SiteHeader/TabletDesktop/Layout/constants.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const TNPLogoStyled = styled.div`
    flex: 0 0 ${convertPxToRem(TNP_LOGO_WIDTH)};
    display: flex;
    align-items: center;
`;

// component
export const TNPLogo = () => {
    return (
        <TNPLogoStyled>
            <CoreTNPLogo />
        </TNPLogoStyled>
    );
};

export default TNPLogo;
